import React, { useContext } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'

import UserContext from '../contexts/userContext'
import LoginPage from './LoginPage'
import Main from './Main'
import UsersPage from './Users/UsersPage'
import PlanetsPage from './Planets/PlanetsPage'
import StreamsPage from './StreamsPage'
import PrivateRoute from './PrivateRoute'
import ProfilePage from './ProfilePage'
import ChatPage from './ChatPage'
import NotificationsPage from './NotificationsPage'
import AdminsPage from './AdminsPage'
import TracksPage from './TracksPage'
import PromocodesPage from './PromocodesPage'
import TipsPage from './Tips/TipsPage';
import LanguagesPage from './Languages/LanguagesPage';
import AutoStreamTracksPage from './AutoStreamTracks/AutoStreamTracksPage';

function Routes() {
    const userContext = useContext(UserContext)

    return !userContext.localAuthChecked ? (
        <Backdrop open={true}>
            <CircularProgress style={{ color: '#fff' }} />
        </Backdrop>
    ) : (
        <Main>
            <UserContext.Consumer>
                {({ isAuthenticated }) =>
                    !isAuthenticated ? (
                        <Switch>
                            <Route path="/login" component={LoginPage} />
                            <Route
                                path="*"
                                render={() => <Redirect to="/login" />}
                            />
                        </Switch>
                    ) : (
                        <Switch>
                            <Route
                                exact
                                path="/"
                                render={() => <Redirect to="/profile" />}
                            />
                            <Route
                                exact
                                path="/login"
                                render={() => <Redirect to="/" />}
                            />
                            <PrivateRoute
                                roles={['admin']}
                                exact
                                path="/users"
                                component={UsersPage}
                            />
                            <PrivateRoute
                                roles={['admin']}
                                exact
                                path="/planets"
                                component={PlanetsPage}
                            />
                            <PrivateRoute
                                roles={['admin']}
                                exact
                                path="/tracks"
                                component={TracksPage}
                            />
                            <PrivateRoute
                                roles={['admin']}
                                exact
                                path="/admins"
                                component={AdminsPage}
                            />
                            <PrivateRoute
                                roles={['streamer', 'admin']}
                                exact
                                path="/streams"
                                component={StreamsPage}
                            />
                            <PrivateRoute
                                roles={['streamer', 'admin']}
                                exact
                                path='/auto-stream-tracks'
                                component={AutoStreamTracksPage}
                            />
                            <PrivateRoute
                                roles={['streamer', 'admin']}
                                exact
                                path="/profile"
                                component={ProfilePage}
                            />
                            <PrivateRoute
                                roles={['admin']}
                                exact
                                path="/chat"
                                component={ChatPage}
                            />
                            <PrivateRoute
                                roles={['admin']}
                                exact
                                path="/notifications"
                                component={NotificationsPage}
                            />
                            <PrivateRoute
                                roles={['admin']}
                                exact
                                path="/promocodes"
                                component={PromocodesPage}
                            />
                            <PrivateRoute
                                roles={['admin']}
                                exact
                                path="/tips"
                                component={TipsPage}
                            />
                            <PrivateRoute
                                roles={['admin']}
                                exact
                                path='/languages'
                                component={LanguagesPage}
                            />
                            <Route
                                path="*"
                                render={() => (
                                    <h1>
                                        4<span role="img">😯</span>4
                                    </h1>
                                )}
                            />
                        </Switch>
                    )
                }
            </UserContext.Consumer>
        </Main>
    )
}

export default Routes
